import React, { Fragment, useEffect, useState } from "react";
import moment from "moment";

export function formatTime(seconds: string) {
	const value = parseInt(seconds, 10);
	const h = Math.floor(value / 3600);
	const min = Math.floor(value / 60) % 60;
	const sec = value % 60;
	return [h, min, sec]
		.map((v) => (v < 10 ? `0${v}` : v))
		.filter((v, i) => v !== "00" || i > 0)
		.join(":");
}

export function convertUntilToSeconds(until: number) {
	return until - moment().unix();
}

export type TimerProps = {
	until: number;
	onSuccess?: () => void;
	suffix?: string
	formatted?: boolean
}

function Timer({ until, onSuccess, suffix, formatted = false }: TimerProps) {
	const [state, setState] = useState(convertUntilToSeconds(until));
	useEffect(() => {
		const interval = setInterval(() => {
			setState((sec) => {
				if (sec < 1) {
					clearInterval(interval);
					if (onSuccess) onSuccess();
					return 0;
				}
				return convertUntilToSeconds(until);
			});
		}, 200);
		return () => clearInterval(interval);
	}, []);
	return (
		<span>
			{ state > 0 && (
				<Fragment>
					{formatted ? formatTime(String(state)) : state}
					{suffix}
				</Fragment>
			)}
		</span>
	);
}

export default Timer;
